import React from 'react';
import { inWindow } from 'api';
import RootWrap from '@/layouts/container/wrap';
const Container = props => inWindow() ? (React.createElement(RootWrap, Object.assign({}, props))) : null;
export default Container;
